import "./loading.scss";
import React from 'react';

export default function Loading({imageLoaded}) {
    const fadeout = imageLoaded ? "fadeout" : "";
    return (<div className={`loading-screen  ${fadeout}`}>
                <svg version="1.1" id="jk-logo" xmlns="http://www.w3.org/2000/svg" strokeLinecap="round" strokeLinejoin="round"  x="0px" y="0px" viewBox="0 0 3000 3000">
                    <g>
                        <polygon className="st1" strokeWidth="40" fill="none" points="1561.5,2144.7 730.5,1313.7 730.5,884.7 1990.5,2144.6"/>
                        <polygon className="st1" strokeWidth="40" fill="none" points="1354.5,1349.5 1657.8,1652.8 2588,1652.8 2284.6,1349.5"/>
                        <polygon className="st1" strokeWidth="40" fill="none" points="419.6,1843.9 723,2147.2 1403.1,2147.2 1099.8,1843.8"/>
                        <polygon className="st1" strokeWidth="40" fill="none" points="1803.5,1097.5 1803.5,1235 1500.5,1235 1500.5,564.5 1803.6,867.6"/>
                    </g>
                </svg>
            </div>

    )
}
